import { useEffect, useRef } from 'react';

const useSetTriggerValue = ({ formMethods, condition, fields = [], value = undefined, isReset = false }) => {
    const resetRef = useRef(false);
    useEffect(() => {
        if (!formMethods || !fields.length) return;
        const setTriggerValue = () => {
            fields.forEach((field) => {
                formMethods.setValue(field, value);
                formMethods.trigger(field);
            });
        };
        if (condition) {
            setTriggerValue();
            resetRef.current = false;
        } else {
            if (isReset) {
                if (!resetRef.current) {
                    fields.forEach((field) => {
                        formMethods.setValue(field, undefined);
                        formMethods.trigger(field);
                    });
                }
                resetRef.current = true;
            }
        }
    }, [condition]);
};

export default useSetTriggerValue;
